<template>
  <div id="ner-page">
    <page-header-component
      v-if="topics"
      @filterChange="filterChange"
      icon="bi bi-bezier"
      title="Named Entity Recognizer (Beta)"
      :topics="topics"
    />

    <div v-if="is_ner" class="row m-t-10">
      <div class="col-3 px-gap">
        <div class="bg-white p-3 rounded shade">
          <h5>Daftar Entitas</h5>
          <input
            id="cari-entitas"
            type="text"
            name="q"
            v-model="q_search"
            @keyup="searchEntity"
            class="form-control form-custom m-b-5"
            placeholder="Cari Entitas"
          />
          <multiselect
            id="jenis-entitas"
            v-model="selected_entity"
            :options="entity_option"
            placeholder="Pilih Jenis Entitas"
            @select="changeEntity"
            label="text"
            track-by="text"
          />
          <p
            class="m-t-10 p-1 bg-warning-lighter"
            align="center"
            v-if="loading_state.entity"
          >
            Loading...
          </p>
          <div
            class="entity-result m-t-10"
            v-else-if="entity_result.length > 0"
          >
            <div
              id="entitas"
              class="row m-t-10"
              :class="entity._id == selected_entity_detail._id ? 'active' : ''"
              v-for="(entity, index) in entity_result"
              :key="index"
              @click="entityDetail(entity)"
            >
              <div class="col-2 no-padding no-margin">
                <div
                  class="bg-icon"
                  :style="
                    entity.type in bg_ner
                      ? 'background-color:' + bg_ner[entity.type]
                      : 'background-color:red'
                  "
                  align="center"
                >
                  <h3><i :class="ner_type_icon[entity.type]" /></h3>
                </div>
              </div>
              <div class="col-10">
                <div class="entity-name">
                  <h5 class="no-margin">
                    {{ entity._id }}
                  </h5>
                </div>
                <div class="entity-count">{{ entity.count }} Mention(s)</div>
              </div>
            </div>
          </div>
          <div v-else class="col-md-12 col-sm-12 col-lg-12">
            <div
              class="alert alert-danger mt-3"
              id="errorApiEl"
              role="alert"
              align="center"
            >
              <strong>Mohon maaf, data tidak tersedia! </strong> <br />
              Silahkan lakukan pencarian dengan parameter lain
            </div>
          </div>
        </div>
      </div>
      <div class="col-9 px-gap">
        <div class="row">
          <div class="col-8 pr-gap">
            <div id="berita-terkait" class="bg-white p-3 rounded shade">
              <h5>
                Berita Terkait
                {{ selected_entity_detail ? selected_entity_detail._id : "" }}
              </h5>

              <p
                class="m-t-10 p-1 bg-warning-lighter"
                align="center"
                v-if="loading_state.post"
              >
                Loading...
              </p>

              <div v-else-if="entity_post" class="entity-post-wrapper">
                <post-list-simple-component
                  :posts="entity_post.posts"
                  :keyword="keyword"
                />
                <pagination-component
                  v-if="entity_post.page_info"
                  :data="entity_post.page_info"
                  :goto="true"
                  :key="pagination_key"
                  class="pull-right"
                  @pageChange="getEntityPost(selected_entity_detail)"
                />
                <div class="clearfix" />
              </div>

              <p
                class="m-t-10 p-1 bg-info-lighter rounded p-1"
                align="center"
                v-else
              >
                Silahkan pilih Entitas terlebih dahulu.
              </p>
            </div>
          </div>
          <div class="col-4 pl-gap">
            <div id="grafik-sentimen" class="bg-white p-3 rounded shade">
              <h5>
                Grafik Sentimen
                {{ selected_entity_detail ? selected_entity_detail._id : "" }}
              </h5>

              <p
                class="m-t-10 p-1 bg-warning-lighter"
                align="center"
                v-if="loading_state.analytic"
              >
                Loading...
              </p>

              <div v-else-if="entity_analytic" style="height: 300px">
                <pie-chart-component :data="piechart_sentiment" />
              </div>

              <p
                class="m-t-10 p-1 bg-info-lighter rounded p-1"
                align="center"
                v-else
              >
                Silahkan pilih Entitas terlebih dahulu.
              </p>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-4 pr-gap">
            <div id="grafik-emosi" class="bg-white p-3 rounded shade">
              <h5>
                Grafik Emosi
                {{ selected_entity_detail ? selected_entity_detail._id : "" }}
              </h5>

              <p
                class="m-t-10 p-1 bg-warning-lighter"
                align="center"
                v-if="loading_state.analytic"
              >
                Loading...
              </p>

              <div v-else-if="entity_analytic" style="height: 300px">
                <pie-chart-component :data="piechart_emotion" />
              </div>

              <p
                class="m-t-10 p-1 bg-info-lighter rounded p-1"
                align="center"
                v-else
              >
                Silahkan pilih Entitas terlebih dahulu.
              </p>
            </div>
          </div>
          <div class="col-8 pl-gap">
            <div id="grafik-tren" class="bg-white p-3 rounded shade">
              <h5>
                Grafik Tren Mention
                {{ selected_entity_detail ? selected_entity_detail._id : "" }}
              </h5>

              <p
                class="m-t-10 p-1 bg-warning-lighter"
                align="center"
                v-if="loading_state.analytic"
              >
                Loading...
              </p>

              <div v-else-if="entity_analytic" style="height: 300px">
                <line-chart-component
                  :series="data_tren_formed"
                  el="linechart-dashboard-mockup"
                  mode="dual"
                />
              </div>

              <p
                class="m-t-10 p-1 bg-info-lighter rounded p-1"
                align="center"
                v-else
              >
                Silahkan pilih Entitas terlebih dahulu.
              </p>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-8 pr-gap">
            <div
              id="grafik-topik"
              class="bg-white p-3 rounded shade"
              style="height: 450px"
            >
              <h5>
                Grafik Topik Terkait
                {{ selected_entity_detail ? selected_entity_detail._id : "" }}
              </h5>

              <p
                class="m-t-10 p-1 bg-warning-lighter"
                align="center"
                v-if="loading_state.analytic"
              >
                Loading...
              </p>

              <div v-else-if="entity_analytic" style="height: 300px">
                <bar-chart-component
                  :series="barchart_topik"
                  :topik="data_topik"
                />
              </div>

              <p
                class="m-t-10 p-1 bg-info-lighter rounded p-1"
                align="center"
                v-else
              >
                Silahkan pilih Entitas terlebih dahulu.
              </p>
            </div>
          </div>
          <div class="col-4 pl-gap">
            <div
              id="keterkaitan"
              class="bg-white p-3 rounded shade"
              style="height: 450px"
            >
              <h5>
                Keterkaitan Entitas
                {{ selected_entity_detail ? selected_entity_detail._id : "" }}
              </h5>

              <p
                class="m-t-10 p-1 bg-warning-lighter"
                align="center"
                v-if="loading_state.analytic"
              >
                Loading...
              </p>

              <div
                v-else-if="entity_analytic"
                style="
                  height: 350px;
                  overflow-y: scroll;
                  overflow-x: hidden;
                  cursor: pointer;
                "
              >
                <div
                  class="row m-t-10"
                  v-for="(entity, index) in entity_analytic.related_entity"
                  :key="index"
                  @click="entityDetail(entity)"
                >
                  <div class="col-2 no-padding no-margin">
                    <div
                      class="bg-icon"
                      :style="
                        entity.type in bg_ner
                          ? 'background-color:' + bg_ner[entity.type]
                          : 'background-color:red'
                      "
                      align="center"
                    >
                      <h3><i :class="ner_type_icon[entity.type]" /></h3>
                    </div>
                  </div>
                  <div class="col-10">
                    <div class="entity-name">
                      <h5 class="no-margin">
                        {{ entity._id }}
                      </h5>
                    </div>
                    <div class="entity-count">
                      {{ entity.count }} Mention(s)
                    </div>
                  </div>
                </div>
              </div>

              <p
                class="m-t-10 p-1 bg-info-lighter rounded p-1"
                align="center"
                v-else
              >
                Silahkan pilih Entitas terlebih dahulu.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row mt-4 px-gap">
      <div class="col-12">
        <div class="bg-white p-l-20 p-t-10 p-r-20 p-b-5 shade">
          <p>Silahkan hubungi administrator untuk membuka fitur ini.</p>
        </div>
      </div>
    </div>
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import Multiselect from "vue-multiselect";
import post_list_simple from "@/views/components/post_list_simple.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import line_chart from "@/views/components/chart/line_chart.vue";
import bar_chart from "@/views/components/chart/bar_chart.vue";
import pagination_component from "@/views/components/pagination.vue";

export default {
  name: "NER",
  title: "Analytics NER | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "post-list-simple-component": post_list_simple,
    "pie-chart-component": pie_chart,
    "line-chart-component": line_chart,
    "bar-chart-component": bar_chart,
    "pagination-component": pagination_component,
    Multiselect,
  },
  data() {
    return {
      tour_steps: [],
      topics: null,
      q_search: null,
      keyword: [],
      selected_entity: null,
      selected_entity_detail: {},
      entity_option: [],
      entity_result: [],
      entity_data: [],
      entity_type_filter: [],
      entity_type_count: [],
      loading_state: {
        entity: false,
        post: false,
        analytic: false,
      },
      entity_post: null,
      entity_analytic: null,
      piechart_sentiment: null,
      piechart_emotion: null,
      data_tren_formed: null,
      barchart_topik: null,
      data_topik: null,
      id_project: this.$store.getters.user.id_project,
      is_ner: this.$store.getters.user.project.project_detail.ner
        ? true
        : false,
      ner_type_icon: this.$ner_icon,
      bg_ner: this.$bg_color,
      pagination_key: 0,
    };
  },
  methods: {
    filterChange: function () {
      this.getData();
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data;
          } else {
            this.topics = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.filterChange();
        });
    },
    getData: function () {
      let api = process.env.VUE_APP_API_URL + "ner_list/" + this.id_project;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      this.entity_data = [];
      this.entity_result = [];
      this.loading_state.entity = true;
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.entity_data = response.data.entity_list;
            this.entity_result = this.entity_data;
            this.entity_type_filter = this.entity_data;
            this.entity_type_count = response.data.entity_info;
            this.entity_option = [
              {
                id: "PER",
                text: "Person (" + this.entity_type_count["PER"] + ")",
              },
              {
                id: "FAC",
                text: "Facility (" + this.entity_type_count["FAC"] + ")",
              },
              {
                id: "ORG",
                text: "Organization (" + this.entity_type_count["ORG"] + ")",
              },
              {
                id: "LOC",
                text: "Location (" + this.entity_type_count["LOC"] + ")",
              },
              {
                id: "PRO",
                text: "Product (" + this.entity_type_count["PRO"] + ")",
              },
              {
                id: "EVT",
                text: "Event (" + this.entity_type_count["EVT"] + ")",
              },
              {
                id: "DTE",
                text: "Date (" + this.entity_type_count["DTE"] + ")",
              },
              {
                id: "OTN",
                text: "Other Name (" + this.entity_type_count["OTN"] + ")",
              },
            ];
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading_state.entity = false;
        });
    },
    changeEntity: function (entity) {
      this.filterEntity(entity);
    },
    filterEntity: function (entity) {
      let result = this.entity_data.filter((ent) => ent.type == entity.id);
      this.entity_type_filter = result;
      this.entity_result = result;
    },
    entityDetail: function (entity) {
      this.selected_entity_detail = entity;
      this.keyword[0] = this.selected_entity_detail._id;
      this.getEntityPost(entity);
      this.getEntityAnalytic(entity);
    },
    getEntityPost: function (entity) {
      let api =
        process.env.VUE_APP_API_URL +
        "ner_posts/" +
        this.id_project +
        "/" +
        entity._id;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      if ("page" in this.$route.query) {
        query.page = this.$route.query.page;
      }
      this.loading_state.post = true;
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.entity_post = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading_state.post = false;
          this.pagination_key++;
        });
    },
    getEntityAnalytic: function (entity) {
      let api =
        process.env.VUE_APP_API_URL +
        "ner_analytics/" +
        this.id_project +
        "/" +
        entity._id;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      this.loading_state.analytic = true;
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.entity_analytic = response.data;
            this.piechartFormat(this.entity_analytic.stats[0]);
            this.linechartFormat(this.entity_analytic.trend_formed);
            this.assembleDataGrafik(this.entity_analytic.bar_topik);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading_state.analytic = false;
        });
    },
    searchEntity: function () {
      let result;
      if (this.selected_entity) {
        result = this.entity_type_filter.filter((ent) =>
          ent._id.toString().toLowerCase().includes(this.q_search.toLowerCase())
        );
      } else {
        result = this.entity_data.filter((ent) =>
          ent._id.toString().toLowerCase().includes(this.q_search.toLowerCase())
        );
      }

      this.entity_result = result;
    },
    piechartFormat: function (dataset) {
      this.piechart_sentiment = [
        {
          name: "Positif",
          y: dataset.positif,
          // sliced: true,
          color: this.$("body").css("--success") + "AA",
        },
        {
          name: "Netral",
          y: dataset.netral,
          color: "#0e6d87AA",
          visible: dataset.positif > 0 && dataset.negatif > 0 ? false : true,
        },
        {
          name: "Negatif",
          y: dataset.negatif,
          color: this.$("body").css("--danger") + "AA",
        },
      ];

      this.piechart_emotion = [
        {
          name: "Netral",
          y: dataset.no_emotion,
        },
        {
          name: "Senang",
          y: dataset.joy,
          color: this.$("body").css("--success") + "AA",
        },
        {
          name: "Takut",
          y: dataset.fear,
          color: this.$("body").css("--warning") + "AA",
        },
        {
          name: "Sedih",
          y: dataset.sad,
          color: this.$("body").css("--teal") + "AA",
        },
        {
          name: "Marah",
          y: dataset.anger,
          color: this.$("body").css("--danger") + "AA",
        },
      ];
    },
    linechartFormat: function (dataset) {
      this.data_tren_formed = {
        y: [
          {
            color: "#28a745",
            name: "Online News",
            data: dataset.news,
            yAxis: 1,
          },
          {
            color: "#e83e8c",
            name: "Media TV",
            data: dataset.media_tv,
          },
          {
            color: "#6c757d",
            name: "Media Cetak",
            data: dataset.media_cetak,
          },
        ],
        x: dataset.date,
        yAxis: ["Jumlah Media Cetak & TV", "Jumlah Online News"],
      };
    },
    assembleDataGrafik: function (data_grafik) {
      if (data_grafik != null) {
        let selected_topic_key = null;
        let data_topik;
        if ("topic" in this.$route.query) {
          data_topik = [];
          for (let key in data_grafik.topics) {
            if (data_grafik.topics[key].id == this.$route.query.topic) {
              data_topik.push(data_grafik.topics[key]);
              selected_topic_key = key;
            }
          }
        } else {
          data_topik = data_grafik.topics;
        }

        let data_tabel = [];
        let data_bar_chart = [];
        let chart_values = {};
        let key_value = [];
        let obj_key_value = {};

        // whitelist data
        let key_grafik = ["positif", "negatif", "netral"];
        for (let obj_key in data_grafik) {
          if (obj_key == "topics") {
            for (let arr_key in data_grafik[obj_key]) {
              if (typeof data_tabel[arr_key] == "undefined") {
                data_tabel[arr_key] = [];
              }
              data_tabel[arr_key][0] = data_grafik[obj_key][arr_key].nama;
            }
          }
          if (key_grafik.includes(obj_key)) {
            key_value = [];
            for (let arr_key in data_grafik[obj_key]) {
              // ini set data buat tabel
              if (obj_key == "positif") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][1] = data_grafik[obj_key][arr_key];
              }
              if (obj_key == "netral") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][2] = data_grafik[obj_key][arr_key];
              }
              if (obj_key == "negatif") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][3] = data_grafik[obj_key][arr_key];
              }

              // set data untuk bar chart
              obj_key_value = {
                x: arr_key,
                y: data_grafik[obj_key][arr_key],
              };
              if (selected_topic_key != null) {
                if (selected_topic_key == arr_key) {
                  key_value.push(obj_key_value);
                }
              } else {
                key_value.push(obj_key_value);
              }
            }
            chart_values = {
              key: this.capitalizeWords(obj_key),
              values: key_value,
            };
            if (obj_key == "positif") data_bar_chart[0] = chart_values;
            if (obj_key == "netral") data_bar_chart[1] = chart_values;
            if (obj_key == "negatif") data_bar_chart[2] = chart_values;
          }
        }
        this.barchart_topik = data_bar_chart;
        this.data_topik = data_topik;
        return {
          table_data: data_tabel,
          grafik_data: data_bar_chart,
          data_topik: data_topik,
        };
      }
    },
    capitalizeWords: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
  },
  watch: {
    selected_entity() {
      if (!this.selected_entity) {
        this.entity_result = this.entity_data;
      }
    },
  },
  created: function () {
    this.getTopic();
  },
  mounted() {
    let v_step = [];
    v_step[0] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#cari-entitas",
      header: {
        title: "Cari Entitas",
      },
      content: `Masukkan kata kunci berupa nama entitas untuk mencari entitas yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#jenis-entitas",
      header: {
        title: "Cari Jenis Enitas",
      },
      content: `Pilih salahsatu jenis entitas untuk melakukan filter sesuai dengan jenis entitas yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#berita-terkait",
      header: {
        title: "Berita Terkait",
      },
      content: `Menampilkan daftar berita terkait entitas yang dipilih. Klik Kunjungi atau Sumber untuk melihat detail sumber dari berita yang dipilih`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#grafik-sentimen",
      header: {
        title: "Grafik Sentimen",
      },
      content: `Menampilkan diagram persentase jumlah sentimen terkait entitas yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#grafik-emosi",
      header: {
        title: "Grafik Emotion",
      },
      content: `Menampilkan diagram persentase jumlah emotion terkait entitas yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#grafik-tren",
      header: {
        title: "Grafik Tren Mention",
      },
      content: `Menampilkan grafik tren mention pada media konvensional terkait entitas yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#grafik-topik",
      header: {
        title: "Grafik Topik",
      },
      content: `Menampilkan grafik topik terkait entitas yang dipilih dengan jumlah topik per sentimen. Klik Grouped untuk melihat grafik dengan sentimen terpisah atau Klik Stacked untuk melihat grafik dengan sentimen bertumpuk`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#keterkaitan",
      header: {
        title: "Grafik Topik",
      },
      content: `Menampilkan daftar entitas yang terkait dengan entitas yang dipilih sebelumnya.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
.entity-result {
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.entity-result .row {
  padding: 10px;
}
.entity-result .row:hover {
  background: #d3eeff !important;
  cursor: pointer;
}
.bg-icon {
  padding: 2px 5px;
}
.bg-icon i {
  color: #ffffff;
}
.active {
  background: #d3eeff !important;
}
.entity-post-wrapper {
  height: 300px;
  overflow-y: scroll;
}
</style>